//Reset data
export const RESET = "CARACTERISATION_UPDATE_RESET"

export const SET_IS_UPDATED = "CARACTERISATION_UPDATE_SET_IS_UPDATED"
export const SET_NOT_UPDATED = "CARACTERISATION_UPDATE_SET_NOT_UPDATED"

export const SET_ELMENT_IS_UPDATED = "CARACTERISATION_UPDATE_SET_ELEMENT_IS_UPDATED"
export const SET_ELMENT_NOT_UPDATED = "CARACTERISATION_UPDATE_SET_ELMENT_NOT_UPDATED"
//Loading
export const SET_TOGGLE_LOADING = "CARACTERISATION_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CARACTERISATION_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CARACTERISATION_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CARACTERISATION_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CARACTERISATION_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CARACTERISATION_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CARACTERISATION_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CARACTERISATION_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CARACTERISATION_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "CARACTERISATION_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "CARACTERISATION_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CARACTERISATION_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CARACTERISATION_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CARACTERISATION_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "CARACTERISATION_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "CARACTERISATION_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CARACTERISATION_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CARACTERISATION_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CARACTERISATION_UPDATE_SET_MODAL_TYPE"